import type { FetchItemUnitsQuery } from '@/features/itemUnits/api'
import type { ItemUnitsSearch } from '@/routes/_protected/$tenantKey/settings/_system-master-settings/item-units/-models/item-units-search'

export function buildFetchItemUnitsQuery(
  tenantKey: string,
  deps: ItemUnitsSearch
): FetchItemUnitsQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
